export const academy = () => (
  <path
    d="M2 10l10 7 10-7-10-7-10 7zm0 0v9m4-6.2V16c0 2.761 2.686 5 6 5s6-2.239 6-5v-3.199"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
